import { Button } from '../components/ui/Button';

interface LoginPageProps {
  onLogin: () => void;
}

export function LoginPage({ onLogin }: LoginPageProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-nav text-white">
      <div className="text-center">
        <h1 className="text-5xl font-bold tracking-wider mb-2">PANTHEON</h1>
        <p className="text-gray-500 text-lg mb-10">PrestoSports's AI-DLC end-to-end software delivery system.</p>
        <Button onClick={onLogin} variant="secondary" size="lg" className="!bg-white !text-gray-900 hover:!bg-gray-100 !px-8 !py-3 !text-base !font-semibold">
          Sign in with Google
        </Button>
      </div>
    </div>
  );
}
